function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M497.919 10L260 284.725L22.0814 10L497.919 10Z",
  fill: "white",
  stroke: "currentColor",
  strokeWidth: 50
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 520,
    height: 300,
    viewBox: "0 0 520 300",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/decrease.39bdc2a6.svg";
export { SvgComponent as ReactComponent };